import React from 'react';
import Widget from '../IframeWidget/Widget';
import * as helper from '../util/helper';
import {
    Page
    , Content
    , Nav
    , PopUp
} from '@beisen/chaos-ui';
import { addEnNavClassName } from '../util/ui';
require('./ApprovalPanel.scss');
/*

*/
class ApprovalPanel extends React.Component {

    constructor(props) {
        super(props);
        this.handleBack = this.handleBack.bind(this);
    }

    handleBack(e) {
        e && e.preventDefault && e.preventDefault();
        this.props.closePanel && this.props.closePanel();
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['ApprovalPanelHandleBack'] = this.handleBack.bind(this);
    }
    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['ApprovalPanelHandleBack'];
    }
    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        helper.clearHeaderConfig();
    }
    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        const { flowChartTitle } = this.props.translation;
        helper.generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'ApprovalPanelHandleBack',
                    control: true,
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            config.titleItem = {
                text: flowChartTitle,
                icon: '',
                callback: '',
                control: false
            };
            return config;
        });
    }

    componentDidMount() {
        if (helper.ifHidePopupNav()) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if (helper.ifHidePopupNav()) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    render() {
        const { flowChartTitle,cancel } = this.props.translation;
        const enNavButtonClass = addEnNavClassName();
        let header = (<Nav title={flowChartTitle}>
            <span role="left" className={enNavButtonClass} onTouchTap={this.handleBack}>{cancel}</span>
        </Nav>);
        if (helper.ifHidePopupNav()) {
            header = null;
        }
        return (
            <PopUp visible={true}
                animation="right-slide-fade"
                maskAnimation="fade"
                cls='approval-pop'
            >
                <Page>
                    {header}
                    <Content>
                        <Widget cmp_data={{ url: this.props.url, mobileurl: this.props.url }} />
                    </Content>
                </Page>
            </PopUp>
        );
    }
}

export default ApprovalPanel;



// WEBPACK FOOTER //
// ./src/components/Approval/ApprovalPanel.js